import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //信息维护-待补全列表
  productTmpList: (data) => apiAxios('post', baseURL + '/admin/product/productTmpList', data),
  // 商品管理-查询绑定辅料
  materialList: (data) => apiAxios('post', baseURL + '/admin/product/productList/materialList', data),
  // 商品管理-维护绑定辅料
  materialUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/materialUpdate', data),
  //信息维护-无需维护列表
  productTmpHideList: (data) => apiAxios('post', baseURL + '/admin/product/productTmpHideList', data),
  //待补全列表-隐藏不维护
  tmpHide: (data) => apiAxios('post', baseURL + '/admin/product/tmpHide', data),
  //待补全列表-隐藏不维护-恢复
  tmpShow: (data) => apiAxios('post', baseURL + '/admin/product/tmpShow', data),
  //待补全列表-填写番号
  updateClientCode: (data) => apiAxios('post', baseURL + '/admin/product/updateClientCode', data),
  //信息维护-数据维护
  productList: (data) => apiAxios('post', baseURL + '/admin/product/productList', data),
  //信息维护-数据维护-修改管理番号
  updateItemClientCode: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateItemClientCode', data),
  //信息维护-数据维护-单链接更换管理番号
  singleLinkUpdateClientCode: (data) => apiAxios('post', baseURL + '/admin/product/productList/singleLinkUpdateClientCode', data),
  //信息维护-数据维护-备注设置
  updateRemark: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateRemark', data),
  //信息维护-数据维护-业务员备注设置
  updateYRemark: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateYRemark  ', data),
  //信息维护-数据维护-业务备注是否下单自动跟随
  updateYRemarkAutoOrder: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateYRemarkAutoOrder', data),
  //信息维护-数据维护-标签设置
  tagUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/tagUpdate', data),
  //信息维护-数据维护-商品标题设置
  updateGoodsTitle: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateGoodsTitle', data),
  //信息维护-数据维护-主图设置
  picUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/picUpdate', data),
  //信息维护-数据维护-备注是否下单自动跟随
  updateRemarkAutoOrder: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateRemarkAutoOrder', data),
  //信息维护-数据维护-长宽高设置
  updateSize: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateSize', data),
  //信息维护-数据维护-重量设置
  updateWeight: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateWeight', data),
  //信息维护-数据维护-设置供货方式
  setProductSupplyType: (data) => apiAxios('post', baseURL + '/admin/product/productList/setProductSupplyType', data),
  //信息维护-数据维护-设置商品违禁类型
  setProductForbidType: (data) => apiAxios('post', baseURL + '/admin/product/productList/setProductForbidType', data),
  //信息维护-数据维护-捆包图设置
  imageUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/imageUpdate', data),
  //信息维护-数据维护-标签设置
  tagUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/tagUpdate', data),
  //信息维护-数据维护-历史标签
  historyGoodsTag: (data) => apiAxios('post', baseURL + '/admin/product/productList/historyGoodsTag', data),
  //信息维护-数据维护-实物图是否可同步
  imageLinkCheck: (data) => apiAxios('post', baseURL + '/admin/product/productList/imageLinkCheck', data),
  //信息维护-数据维护-实物图同步
  imageLinkSyncCheck: (data) => apiAxios('post', baseURL + '/admin/product/productList/imageLinkSyncCheck', data),
  //信息维护-数据维护-option设置
  updateOption: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateOption', data),
  //信息维护-数据维护-购买信息设置
  setBuyChannel: (data) => apiAxios('post', baseURL + '/admin/product/productList/setBuyChannel', data),
  //信息维护-数据维护-文件分类添加
  fileCateStore: (data) => apiAxios('post', baseURL + '/admin/product/productList/fileCateStore', data),
  //信息维护-数据维护-文件分类修改
  fileCateUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/fileCateUpdate', data),
  //信息维护-数据维护-文件分类删除
  fileCateDelete: (data) => apiAxios('post', baseURL + '/admin/product/productList/fileCateDelete', data),
  //信息维护-数据维护-文件设置
  fileUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/fileUpdate', data),
  //信息维护-数据维护-品名材质设置
  updateClearancePingming: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateClearancePingming', data),
  //信息维护-数据维护-通关编码设置
  setHsCode: (data) => apiAxios('post', baseURL + '/admin/product/productList/setHsCode', data),
  //信息维护-数据维护-通关编码查询
  searchHscodeOption: (data) => apiAxios('post', baseURL + '/admin/product/productList/searchHscodeOption', data),
  //信息维护-数据维护-标记列表
  flagList: (data) => apiAxios('post', baseURL + '/admin/product/productList/flag/flagList', data),
  // 信息维护-批量审核完成
  batchAuditApprove: (data) => apiAxios('post', baseURL + '/admin/product/productList/batchAuditApprove', data),
  // 信息维护-批量审核驳回
  batchAuditReject: (data) => apiAxios('post', baseURL + '/admin/product/productList/batchAuditReject', data),

  //进行中商品-列表
  productOrderingList: (data) => apiAxios('post', baseURL + '/admin/product/productOrderingList', data),
  //历史商品-列表
  productOrderedList: (data) => apiAxios('post', baseURL + '/admin/product/productOrderedList', data),
  //点击-不良列表
  problemListDetail: (data) => apiAxios('post', baseURL + '/admin/product/productList/problemListDetail', data),
  //点击-订单单番明细
  orderDetail: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderDetail', data),
  //点击-配送单出货列表
  porderDeliveryList: (data) => apiAxios('post', baseURL + '/admin/product/productList/porderDeliveryList', data),

  //弹窗-具体数字明细
  orderingDataDialog: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderingDataDialog', data),
  //商品数据分析
  totalCache: (data) => apiAxios('post', 'https://apimanage.rakumart.com/admin/product/productTotal/totalCache', data),
  //商品数据分析-导出excel
  totalCacheExport: (data) => apiAxios('post', 'https://apimanage.rakumart.com/admin/product/productTotal/totalCacheExport', data),
  //那商品ID查看明细
  goodsIdDetail: (data) => apiAxios('post', 'https://apimanage.rakumart.com/admin/product/productTotal/goodsIdDetail', data),
  //信息维护-生成默认管理番号
  randClientSkuCode: (data) => apiAxios('post', baseURL + '/admin/product/randClientSkuCode', data),

  // 商品管理-业务汇总
  getClientPageFilterCols: (data) => apiAxios('post', baseURL + '/admin/product/productList/getClientPageFilterCols', data),
  // 商品管理-业务汇总页面
  clientProductList: (data) => apiAxios('post', baseURL + '/admin/product/productList/clientProductList', data),
  // 信息维护-数据维护-批量是否停用
  switchHide: (data) => apiAxios('post', baseURL + '/admin/product/productList/switchHide', data),
  // 信息维护-数据维护-批量标识维护状态
  switchEditStatus: (data) => apiAxios('post', baseURL + '/admin/product/productList/switchEditStatus', data),
  // 信息维护-导出
  productListExport: (data) => apiAxios('post', baseURL + '/admin/product/productList/export', data),
  // 信息维护-导入
  productListImport: (data) => apiAxios('post', baseURL + '/admin/product/productList/import', data),

  // 信息维护-批量更新-基础设置
  batchUpdateBase: (data) => apiAxios('post', baseURL + '/admin/product/productList/batchUpdateBase', data),
  // 信息维护-批量更新-购买信息
  batchUpdatePurchase: (data) => apiAxios('post', baseURL + '/admin/product/productList/batchUpdatePurchase', data),
  // 信息维护-批量更新--标签设置
  batchUpdateTag: (data) => apiAxios('post', baseURL + '/admin/product/productList/batchUpdateTag', data),
  // 信息维护-批量更新-OPTION设置
  updateOption: (data) => apiAxios('post', baseURL + '/admin/product/productList/updateOption', data),
  // 信息维护-批量更新-发票设置
  batchUpdateInvoice: (data) => apiAxios('post', baseURL + '/admin/product/productList/batchUpdateInvoice', data),
  // 信息维护-批量更新-文件设置
  batchUpdateFile: (data) => apiAxios('post', baseURL + '/admin/product/productList/batchUpdateFile', data),

  // 下单方案
  // 下单方案列表
  orderPlanList: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderPlan/orderPlanList', data),
  // 新增下单方案
  orderPlanStore: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderPlan/orderPlanStore', data),
  // 编辑下单方案
  orderPlanUpdate: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderPlan/orderPlanUpdate', data),
  // 删除下单方案
  orderPlanDelete: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderPlan/orderPlanDelete', data),
  // 设置默认下单方案
  orderPlanSetDefault: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderPlan/orderPlanSetDefault', data),
  // 根据最近一次下单数据生成默认方案
  generateDefaultPlan: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderPlan/generateDefaultPlan', data),
  // 获取最新下单链接
  getLatestLink: (data) => apiAxios('post', baseURL + '/admin/product/productList/orderPlan/getLatestLink', data),



  // v2
  // 商品管理-列表
  productListV2: (data) => apiAxios('post', baseURL + '/admin/product/v2/productList', data),
  // V2-Tab数量
  tabCounts: (data) => apiAxios('post', baseURL + '/admin/product/v2/tabCounts', data),
  // V2-批量提交审核
  submitAudit: (data) => apiAxios('post', baseURL + '/admin/product/v2/submitAudit', data),
  // V2-批量提交无需维护
  submitNoNeed: (data) => apiAxios('post', baseURL + '/admin/product/v2/submitNoNeed', data),
  // V2-批量审核
  batchAudit: (data) => apiAxios('post', baseURL + '/admin/product/v2/batchAudit', data),
  // V2-提出订单校验
  raiseOrderCheck: (data) => apiAxios('post', baseURL + '/admin/product/v2/raiseOrderCheck', data),
  // 商品管理后台-删除商品
  deleteProduct: (data) => apiAxios('post', baseURL + '/admin/product/deleteProduct', data),
  // V2-历史采购链接
  historyPurchaseLinks: (data) => apiAxios('post', baseURL + '/admin/product/v2/historyPurchaseLinks', data),
  // V2-更新管理番号
  updateClientSkuCode: (data) => apiAxios('post', baseURL + '/admin/product/v2/updateClientSkuCode', data),
  // V2-更新管理番号
  manualCreate: (data) => apiAxios('post', baseURL + '/admin/product/v2/manualCreate', data),
  // V2-同步开关查询
  syncSettingGet: (data) => apiAxios('post', baseURL + '/admin/product/v2/syncSettingGet', data),

  // V2-同步开关设置
  syncSettingSet: (data) => apiAxios('post', baseURL + '/admin/product/v2/syncSettingSet', data),
  // V2-违禁品枚举
  forbidTypeOptions: (data) => apiAxios('post', baseURL + '/admin/product/v2/forbidTypeOptions', data),
  // V2-设置番号违禁品
  setForbidType: (data) => apiAxios('post', baseURL + '/admin/product/v2/setForbidType', data),
  // V2-商品详情获取
  detailGet: (data) => apiAxios('post', baseURL + '/admin/product/v2/detailGet', data),
  // V2-商品详情保存(创建或修改)
  detailSave: (data) => apiAxios('post', baseURL + '/admin/product/v2/detailSave', data),
  // 从订单详情创建商品管理数据
  createFromOrderDetail: (data) => apiAxios('post', baseURL + '/admin/product/createFromOrderDetail', data),
  // V2-下单记录含赔款
  orderHistory: (data) => apiAxios('post', baseURL + '/admin/product/v2/orderHistory', data),
  // V2-按客户补订单明细 for_sn
  syncOrderDetailForSn: (data) => apiAxios('post', baseURL + '/admin/product/v2/syncOrderDetailForSn', data),
  // V2-发票AI自动获取
  clearanceAiSuggest: (data) => apiAxios('post', baseURL + '/admin/product/v2/clearanceAiSuggest', data),
  // V2-变更日志列表
  changeLogList: (data) => apiAxios('post', baseURL + '/admin/product/v2/changeLogList', data),
  // V2-SPU列表（按客户分页，支持 SPU/名称模糊）
  spuList: (data) => apiAxios('post', baseURL + '/admin/product/v2/spuList', data),
  // V2-SPU创建或编辑
  spuSave: (data) => apiAxios('post', baseURL + '/admin/product/v2/spuSave', data),
  // V2-删除SPU
  spuDelete: (data) => apiAxios('post', baseURL + '/admin/product/v2/spuDelete', data),
  // V2-绑定SPU
  spuBind: (data) => apiAxios('post', baseURL + '/admin/product/v2/spuBind', data),

}
